<div data-testid="third-party-goods-page" class="p-4 flex-table-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "third_party.goods.title" | translate }}
  </h2>

  <app-search-form
    data-testid="third-party-goods-search-form"
    [searchFormat]="searchFormat"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
  </app-search-form>

  <div class="flex-table-section">
    <advanced-data-table
      data-testid="third-party-goods-table"
      [dataSource]="items()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="[]"
      [rows]="pageSize()"
      [first]="first()"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [loading]="loading()"
      [showInternalColumnConfigButton]="true"
      (pageChange)="onPageChange($event)"
    >
    <ng-template #customTemplate let-value let-column="column">
      @if (column?.template === "currencyTemplate") {
        <span class="text-xs text-gray-600 text-right">{{
          formatCurrency(value)
        }}</span>
      }
    </ng-template>
    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1">
        <p-tag
          data-testid="third-party-goods-status-tag"
          [value]="getStatusDisplayText(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(status)"
          [pTooltip]="getStatusDisplayText(status)"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>
    <ng-template #actionsTemplate let-rowData>
      @if (isLazadaChannelCode(rowData.channelType) || isShopeeChannelCode(rowData.channelType)) {
        <div class="flex gap-2 justify-center flex-wrap">
          @if (canUpdate()) {
            <app-button
              [testId]="'third-party-goods-action-edit-' + (rowData.id || rowData.skuId || rowData.spuId || rowData.itemId || rowData.code)"
              class="action-edit"
              [label]="'common.actions.edit' | translate"
              type="action"
              (emitOnClick)="onEdit(rowData)"
            ></app-button>
          }
          @if (canUpdate() && rowData.status === "DRAFT") {
            <app-button
              [testId]="'third-party-goods-action-activate-' + (rowData.id || rowData.skuId || rowData.spuId || rowData.itemId || rowData.code)"
              class="action-enable"
              [label]="
                'onlineStore.form.product_list.actions.activate' | translate
              "
              type="action"
              (emitOnClick)="onActivate(rowData)"
            ></app-button>
          }
          @if (canRead()) {
            <app-button
              [testId]="'third-party-goods-action-view-' + (rowData.id || rowData.skuId || rowData.spuId || rowData.itemId || rowData.code)"
              class="action-view"
              [label]="'common.actions.view' | translate"
              type="action"
              (emitOnClick)="onView(rowData)"
            ></app-button>
          }
          @if (canDelete() && rowData.status === "ACTIVE") {
            <app-button
              [testId]="'third-party-goods-action-deactivate-delete-' + (rowData.id || rowData.skuId || rowData.spuId || rowData.itemId || rowData.code)"
              class="action-delete"
              [label]="
                'onlineStore.form.product_list.actions.deactivate_and_delete'
                  | translate
              "
              type="action"
              (emitOnClick)="onDelete(rowData)"
            ></app-button>
          }
          @if (
            canDelete() &&
            (rowData.status === "DRAFT" || rowData.status === "INACTIVE")
          ) {
            <app-button
              [testId]="'third-party-goods-action-delete-' + (rowData.id || rowData.skuId || rowData.spuId || rowData.itemId || rowData.code)"
              class="action-delete"
              [label]="'common.actions.delete' | translate"
              type="action"
              (emitOnClick)="onDelete(rowData)"
            ></app-button>
          }
        </div>
      }
    </ng-template>
    </advanced-data-table>
  </div>

  <app-confirmation-dialog
    data-testid="third-party-goods-delete-dialog"
    [visible]="showProductDeleteDialog()"
    (visibleChange)="showProductDeleteDialog.set($event)"
    [title]="productDeleteDialogTitle()"
    [message]="productDeleteDialogMessage()"
    [buttons]="productDeleteDialogButtons()"
    (emitOnClick)="onProductDeleteDialogAction($event)"
  ></app-confirmation-dialog>
  <p-toast data-testid="third-party-goods-toast"></p-toast>
</div>
